import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Linkedin, Facebook } from 'lucide-react';
import { BRAND, NAV } from '../data/mock';

const Footer = () => {
  return (
    <footer className="relative bg-[#72272D] text-[#F5F0E5]">
      {/* Top gold hairline */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#C9A875]/40 to-transparent" />

      <div className="container-x py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="inline-flex items-center group">
              <img
                src={BRAND.logo}
                alt="Tarhun Catering"
                className="h-[140px] w-auto object-contain"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </Link>
            <p className="text-cream-78 mt-6 max-w-md text-[14px] leading-relaxed">
              Kurumsal yemek operasyonunun sessiz mimarı. Fabrika, ofis ve şantiyeler için 365 gün; aynı saat, aynı kalite, aynı disiplin.
            </p>
            <div className="flex items-center gap-3 mt-8">
              {[
                { Icon: Instagram, label: 'Instagram', href: BRAND.instagram },
                { Icon: Linkedin,  label: 'LinkedIn',  href: BRAND.linkedin },
                { Icon: Facebook,  label: 'Facebook',  href: BRAND.facebook },
              ].map(({ Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`Tarhun Catering — ${label}`}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="h-9 w-9 grid place-items-center border border-cream-15 hover:border-[#C9A875] hover:text-[#C9A875] text-cream-65 transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[12px] tracking-[0.3em] text-[#C9A875] uppercase font-sans font-medium mb-5">
              Sayfalar
            </h4>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <Link
                    to={n.href}
                    className="text-cream-78 hover:text-[#C9A875] text-[13px] tracking-wide transition-colors"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[12px] tracking-[0.3em] text-[#C9A875] uppercase font-sans font-medium mb-5">
              İletişim
            </h4>
            <ul className="space-y-4 text-[13px] text-cream-85">
              <li className="flex items-start gap-3">
                <Phone size={15} className="text-[#C9A875] mt-0.5 shrink-0" />
                <a href={`tel:${BRAND.phoneRaw}`} className="hover:text-[#C9A875] transition-colors">
                  {BRAND.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={15} className="text-[#C9A875] mt-0.5 shrink-0" />
                <a href={`tel:${BRAND.fax.replace(/\s/g, '')}`} className="hover:text-[#C9A875] transition-colors">
                  {BRAND.fax}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={15} className="text-[#C9A875] mt-0.5 shrink-0" />
                <a href={`mailto:${BRAND.email}`} className="hover:text-[#C9A875] transition-colors">
                  {BRAND.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="text-[#C9A875] mt-0.5 shrink-0" />
                <span>{BRAND.address}</span>
              </li>
            </ul>

            <div className="mt-8 p-5 border border-[#C9A875]/25">
              <div className="text-[11px] tracking-[0.3em] uppercase text-[#C9A875] mb-2">
                Çalışma Saatleri
              </div>
              <div className="text-[13px] text-cream-85">
                Pazartesi — Cumartesi · 07:00 — 22:00
              </div>
              <div className="text-[12px] text-cream-55 mt-1">
                Operasyon hattı 7/24 aktiftir
              </div>
            </div>
          </div>
        </div>

        <div className="my-12 h-px bg-gradient-to-r from-transparent via-[#C9A875]/30 to-transparent" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-[12px] text-cream-45">
          <div>© {new Date().getFullYear()} Tarhun Catering. Tüm hakları saklıdır.</div>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-[#C9A875] transition-colors">KVKK</a>
            <a href="#" className="hover:text-[#C9A875] transition-colors">Gizlilik Politikası</a>
            <a href="#" className="hover:text-[#C9A875] transition-colors">Çerez Politikası</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
